<template>
  <div class="countContainer px-2">
    <search
      class="count-search"
      placeholder="请输入姓名/部门"
      @search="searchName"
    ></search>
    <div class="list mb-2 px-4 py-2">
      <div
        class="item"
        @click="toCountDetail(item.empid)"
        v-for="(item, index) in teamList"
        :key="index"
      >
        <div>
          <div
            class="img-box"
            :style="{
              backgroundImage: 'url(' + item.avatar + ')',
            }"
          >
            <img :src="item.avatar" alt="" />
          </div>
          <div class="name ml-2">
            <p>{{ item.name }}</p>
            <p>{{ item.deptname }}</p>
          </div>
        </div>
        <span v-if="type == 1 || type == 2"
          >{{ typeName + item.sumtimes + "次" }}（{{
            item.sumtotal | fromatNum
          }}分钟）</span
        >
        <span v-else-if="type == 4">{{ typeName + item.sumtotal }}次</span>
        <span v-else>{{ typeName }}{{ item.sumtotal | fromatNum }} 小时</span>
      </div>
      <van-empty v-if="teamList.length == 0" description="暂无数据" />
    </div>
  </div>
</template>

<script>
import search from "@/components/space/search.vue";
import api from '@/apis'
export default {
  components: { search },
  data() {
    return {
      header: require("@/assets/logo.png"),
      teamList: [],
      month: this.$route.query.month,
      typeName: this.$route.query.name.replace(/（[^)]*）/g, ""),
      type: this.$route.query.type,
      search: {},
    };
  },
  created() {
    document.title = this.typeName + "统计";
    this.teamStatistic();
  },
  filters: {
    fromatNum(e) {
      return parseFloat(e).toFixed(2);
    },
  },
  methods: {
    //跳转
    toCountDetail(id) {
      this.$router.push({
        path: "/countDetail",
        query: {
          empid: id,
          month: this.month,
          name: this.typeName,
          type: this.type,
        },
      });
    },
    // 搜索
    searchName(e) {
      if (e) {
        this.search = {
          name: e.keyword,
        };
      } else {
        this.search = {};
      }

      this.teamStatistic();
    },

    // 获取数据列表
    teamStatistic() {
      let data = {
        month: this.month + "-01",
        type: this.type,
      };
      if (this.search) data = { ...data, ...this.search };
      api.teamStatistic(data).then((res) => {
        this.teamList = res.data;
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.countContainer {
  @include container();
  &::v-deep .count-search {
    .van-search {
      background: transparent;
      padding-left: 0;
      padding-right: 0;
    }
    .van-search__content {
      background: #ffffff;
    }
  }
  .list {
    background: #ffffff;
    border-radius: 10px;
    .item {
      height: 135px;
      @include flex-between();
      cursor: pointer;

      & > div {
        @include flex-start();
        align-items: center;
        .img-box {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          overflow: hidden;
          background-repeat: no-repeat;
          background-size: 100% auto;
          background-position: center center;
          & > img {
            width: 100%;
            height: 100%;
            opacity: 0;
          }
        }
        .name {
          & > p:nth-child(1) {
            font-size: 30px;
            font-family: SimHei;
            font-weight: 500;
            color: #1e1e1e;
          }
          & > p:nth-child(2) {
            font-size: 24px;
            font-family: SimHei;
            font-weight: 400;
            color: #999999;
          }
        }
      }

      & > span {
        font-size: 30px;
        font-family: SimHei;
        font-weight: 400;
        color: #ff0000;
      }
    }
    .item:not(:last-child) {
      border-bottom: 1px solid #dedede;
    }
  }
}
</style>